export default "__VITE_ASSET__thod0MUh__"